export const EmptyComponentCategory = '_'
